var mapOffset = {};
var stickySeatsLeft = Odigeo._.throttle(function($element, name) {
    var seatsLeftOffsetTop = $element.offset().top;
    mapOffset[name] = $element.hasClass('od-sticky-seats-left') ? mapOffset[name] : seatsLeftOffsetTop;
    $element.toggleClass('od-sticky-seats-left', $(window).scrollTop() > mapOffset[name]);
}, 100, {
    'trailing': true,
    'leading': true,
});
module.exports = {
    stickyTopSeats: function($element, name) {
        Odigeo.addScrollListener({
            name: name,
            fn: Odigeo._.bind(stickySeatsLeft, this, $element, name),
            pageName: Odigeo.History.getPageNameFromFragment(),
        });
    },
};
